import AddArticles from "./articles/addArticles";
import EditArticles from "./articles/editArticles";
import ListArticles from "./articles/listArticles";
import * as Styled from "./styled";
import Sidemenu from "../../components/sidemenu";
import { Button } from "react-bootstrap";

const AdminPanel = (props) => {
  return (
    <Styled.MainDiv>
      <Sidemenu />
      <Styled.ColumnDiv>{
        props.title=="Add" ?
        <AddArticles />:props.title=="Edit" ? <EditArticles/>:props.title=="List" && <ListArticles/>
        }
      
      </Styled.ColumnDiv>
    </Styled.MainDiv>
  );
};

export default AdminPanel;
